import { SVGProps, Ref, forwardRef } from 'react';

export const ListShortOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M4 8.5C4 7.75 4.375 7 5.5 7S7 7.75 7 8.5 6.625 10 5.5 10 4 9.25 4 8.5" fill="currentColor" />
            <path d="M4 15.5c0-.75.375-1.5 1.5-1.5s1.5.75 1.5 1.5S6.625 17 5.5 17 4 16.25 4 15.5" fill="currentColor" />
            <path d="M9 9.4h11V7.6H9z" fill="currentColor" />
            <path d="M9 16.4h11v-1.8H9z" fill="currentColor" />
        </g>
    </svg>
));
ListShortOutlinedSize24Glyph.displayName = 'ListShortOutlinedSize24Glyph';
